import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import Logs from '../school/Logs';
import dayjs from 'dayjs';
import OrphanTable from './OrphanTable';
import { getMosque, getContactByMosqueId } from 'lib/supabaseQueries';

const MosqueDetails = () => {
  const { id } = useParams();

  const { data: mosqueData } = useQuery({
    queryKey: ['mosque', id],
    queryFn: () => getMosque(id),
    enabled: !!id
  });

  const { data: contactData } = useQuery({
    queryKey: ['contact', 'mosque', id],
    queryFn: () => getContactByMosqueId(id),
    enabled: !!id
  });

  const mosque = mosqueData?.data;
  const contacts = contactData?.data || [];

  return (
    <Fragment>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="fw-bold">Mosque Details</h4>}
          light={false}
          titleTag="div"
          className="pb-1"
          menuClassName="align-items-start"
        />

        <Card.Body>
          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Serial Number</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Address</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>City</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Country</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>
                    {mosque?.serial_number}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{mosque?.address}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{mosque?.city}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{mosque?.country}</p>
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Mosque Name</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Registered Date</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Documents</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{mosque?.name}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>
                    {dayjs(mosque?.created_at).format(
                      'MMM-DD-YYYY'
                    )}
                  </p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{mosque?.email}</p>
                  {mosque?.document ? (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>
                      <a
                        href={mosque?.document}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {' '}
                        File URL{' '}
                      </a>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
          <hr />

          <FalconCardHeader
            title={<h4 className="fw-bold">Person To Contact</h4>}
            light={false}
            titleTag="div"
            className="p-0 pb-3"
            menuClassName="align-items-start"
          />

          <Row>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Title</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Name</p>
                </div>
                <div>
                  <p className="mb-2 text-primary" style={{ fontSize: '1rem' }}>
                    {contacts[0]?.title}
                  </p>
                  {contacts[0] && (
                    <p className="mb-2" style={{ fontSize: '1rem' }}>
                      {`${contacts[0].first_name} ${contacts[0].last_name}`}
                    </p>
                  )}
                </div>
              </Flex>
            </Col>
            <Col>
              <Flex>
                <div className="donor-info-title">
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Email</p>
                  <p className="mb-2 text-900" style={{ fontSize: '1rem' }}>Phone Number</p>
                </div>
                <div>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contacts[0]?.email}</p>
                  <p className="mb-2" style={{ fontSize: '1rem' }}>{contacts[0]?.phone}</p>
                </div>
              </Flex>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row className="my-3">
        <Col md={12} xxl={12} className="h-md-100">
          <OrphanTable />
        </Col>
      </Row>

      <Logs moduleType="Mosque" />
    </Fragment>
  );
};

export default MosqueDetails;
